<script lang="ts" module>
  import { collectionContext } from "#lib/internal/helpers/collectionContext"

  const triggerContext = collectionContext()
  export const getTriggerCollection = triggerContext.getContext
</script>

<script lang="ts">
  import { useActions } from "#lib/internal/helpers"
  import { enableGroupKeyboardNavigation } from "#lib/internal/helpers/group"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import type { HTMLAttributes } from "svelte/elements"
  import { getTabsRootContext } from "./TabsRoot.svelte"

  type Props = HTMLAttributes<HTMLDivElement> & {
    class?: string | undefined | null
    use?: any[]
    children?: Snippet
    triggerCollection?: ReturnType<typeof triggerContext.setContext>
  }

  let {
    class: className = undefined,
    use = [],
    children,
    triggerCollection = $bindable(),
    ...restProps
  }: Props = $props()

  const rootCtx = getTabsRootContext()
  triggerCollection = triggerContext.setContext()

  const listeners = /* @__PURE__ */ new Map()

  $effect(() => {
    enableGroupKeyboardNavigation(
      triggerCollection,
      listeners,
      $rootCtx.orientation,
      $rootCtx.dir
    )
  })
</script>

<div
  class={cn(
    "inline-flex items-center justify-center rounded bg-muted p-1 text-muted-foreground data-[orientation=horizontal]:h-10 data-[orientation=vertical]:h-fit",
    className
  )}
  role="tablist"
  data-orientation={$rootCtx.orientation}
  {...restProps}
  use:useActions={use}
>
  {@render children?.()}
</div>
